export default "__VITE_ASSET__rF6iNNzg__"